import { useRouter } from 'next/router'
import { useEffect } from 'react'

import excludeBlankKeys from '@/helpers/excludeBlankKeys'
import {
  setFieldset,
  setPriceRange,
} from '@/zustand/stores/price-range/usePriceRangeStore'

function usePriceRangeState(
  min: number,
  max: number,
  range?: (number | null)[]
) {
  const { push, query: params } = useRouter()

  const handleMove = (values: number[]) => {
    setPriceRange(values)
    setFieldset(values)
  }

  const handleMoveEnd = (values: number[]) => {
    const [price_from, price_to] = values
    const x = price_from > 0 ? price_from : null
    const y = price_to > 0 ? price_to : null
    const query = excludeBlankKeys<string>({
      ...params,
      price_from: x,
      price_to: y,
      page: null,
    })

    push({ query }, undefined, { shallow: true })
  }

  useEffect(() => {
    if (range) {
      const [price_from, price_to] = range
      const validRange = [price_from ?? min, price_to ?? max]
      setPriceRange(validRange)
      setFieldset(validRange)
    }
  }, [range, max])

  return { handleMove, handleMoveEnd }
}

export default usePriceRangeState
